import { IBaseEntity, ProfileType } from '.';

const IAM_RESOURCE = 'api.modernization';

export type IAMPermission = {
  resource?: string;
  resourceId?: string;
  permission: string;
};

export const UserPermissions: Record<string, IAMPermission> = {
  ADMIN: { resource: IAM_RESOURCE, permission: 'Administrator' },
  MODERATOR: { resource: IAM_RESOURCE, permission: 'Moderator' },
  AUDITOR: { resource: IAM_RESOURCE, permission: 'Auditor' },
  REVIEWER: { resource: IAM_RESOURCE, permission: 'Reviewer' },
  ARCHITECT: { resource: IAM_RESOURCE, permission: 'Architect' },
};

export interface IUser extends IBaseEntity {
  email: string;
  resetLocaleStorage: boolean;
  profileType: ProfileType | null;
  notificationLevel: string;
}

export interface IUserUpdate {
  resetLocaleStorage?: boolean;
  profileType?: ProfileType | null;
}

export interface IResponseUser extends IBaseEntity {
  users: IUser[];
}

export type UserNotificationLabels = Record<string, string>;
